import { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { SocketContext } from '../../context/SocketContext'
import { useHideMenu } from '../../hooks/useHideMenu'
import { useGetPantallas } from '../../hooks/useGetPantallas';
import { getUsuarioStorage } from '../../helpers/getUsuarioStorage'

import LoadingOverlay from '../../components/LoadingOverlay'
import { SelectElement } from "../../components/selectElement2";
import { NoAcceso } from '../../components/NoAcceso';
import { serverApi } from '../../api';


const chipStyle = {
    background: '#f1f5f9', color: '#475569', fontWeight: 700,
    padding: '5px 11px', borderRadius: 999, fontSize: 12,
    display: 'inline-flex', alignItems: 'center', gap: 5,
    whiteSpace: 'nowrap', lineHeight: 1.4,
};

const chipOk = { background: '#d1fae5', color: '#047857' };
const chipNo = { background: '#e2e8f0', color: '#64748b' };


export const ModulosTipoAtencionPage = () => {

    const { socket } = useContext(SocketContext);
    const usuario = useMemo(() => getUsuarioStorage(), []);
    const pantallas = useGetPantallas();

    const [isLoading, setIsLoading] = useState(false);
    const [modulo, setModulo] = useState([]);

    const [ubicaciones, setUbicaciones] = useState([]);

    const [query, setQuery] = useState({
        search: '',
        page: 1,
        limit: 10,
        sortBy: 'tipoAtencion',
        sortDir: 'asc',
        ideUbicacion: '',
        codigoUbicacion: usuario.codigoUbicacion,
        uidModulo: ''
    });

    const navigate = useNavigate();
    useEffect(() => {
        if (usuario.uidUsuario === null) {
            navigate("/Ingreso")
        }
    }, [usuario.uidUsuario, navigate])

    useHideMenu(false);




    // tabla
    const [data, setData] = useState([]);
    const [buscar, setBuscar] = useState('');





    //Select-ubicaciones
    useEffect(() => {

        const codigoEntidad = localStorage.getItem("codigoEntidad");

        if (!codigoEntidad) return;

        const fetch = async () => {
            try {

                const resp = await serverApi.post(`/ubicaciones/select-ubicaciones`, { codigoEntidad });

                const opciones = resp.data.data.map((item) => ({ value: item.ideUbicacion, label: item.nombreUbicacion.toUpperCase(), data: item.codigoUbicacion }))
                setUbicaciones(opciones);

                const ubicacionUsuario = opciones.find(
                    u => u.data === usuario.codigoUbicacion
                );

                if (ubicacionUsuario) {
                    setQuery(prev => ({
                        ...prev,
                        ideUbicacion: ubicacionUsuario.value,
                        codigoUbicacion: ubicacionUsuario.data
                    }));
                }

            } catch (error) {
                console.error("Error al obtener clases Modulos", error);
            } finally {

            }
        };

        fetch();

    }, [usuario])

    // Carga los módulos de una sede (param opcional; por defecto usa la sede de query/usuario)
    const cargarModulos = useCallback(async (codigoUbicacionParam) => {

        const codigoEntidad = localStorage.getItem("codigoEntidad");

        if (!codigoEntidad) return;

        const codigoUbicacion = codigoUbicacionParam || (query.codigoUbicacion === "" ? usuario.codigoUbicacion : query.codigoUbicacion);
        if (!codigoUbicacion) return;

        try {

            const resp = await serverApi.post(`/modulos/select-modulos`, { codigoEntidad, codigoUbicacion });

            const opciones = resp.data.listaModulos.map((item) => ({ value: item.uidModulo, label: ` ${item.moduloClase.toUpperCase()} - ${item.modulo.toUpperCase()} ` }))
            setModulo(opciones)

        } catch (error) {
            console.error("Error al obtener clases Modulos", error);
        }

    }, [query.codigoUbicacion, usuario]);

    useEffect(() => {

        cargarModulos();

    }, [cargarModulos]);

    // Carga la lista de tipos de atención según la sede y el módulo seleccionados.
    // Se usa al cambiar de sede/módulo y también después de cada activación/desactivación,
    // para que el cambio se vea en pantalla sin recargar la ventana.
    const peticionRef = useRef(0);

    const cargarTiposAtencion = useCallback(async (overrides = {}) => {

        const codigoEntidad = usuario.codigoEntidad;
        if (!codigoEntidad) return;

        // Correlativo para descartar respuestas que lleguen fuera de orden
        const idPeticion = ++peticionRef.current;

        try {

            setIsLoading(true);

            const codigoUbicacion = overrides.codigoUbicacion || (query.codigoUbicacion === "" ? usuario.codigoUbicacion : query.codigoUbicacion);

            const resp = await serverApi.post(
                `/modulos/modulo-tiposAtencion`,
                {
                    ...query,
                    ...overrides,
                    codigoEntidad,
                    codigoUbicacion
                }
            );

            if (idPeticion !== peticionRef.current) return; // respuesta vieja, se ignora

            setData(resp.data.listaAtenciones || []);

        } catch (error) {
            console.error("Error al obtener tipos de atención", error);
        } finally {
            if (idPeticion === peticionRef.current) setIsLoading(false);
        }

    }, [query, usuario]);

    useEffect(() => {

        cargarTiposAtencion();

    }, [cargarTiposAtencion]);

    useEffect(() => {

        if (!socket) return;

        const handler = (payload) => {

            // Compatibilidad: antes el evento traía directamente la lista
            const lista = Array.isArray(payload) ? payload : payload?.lista;
            if (!Array.isArray(lista)) return;

            if (!Array.isArray(payload)) {

                const codigoUbicacionActual = query.codigoUbicacion === "" ? usuario.codigoUbicacion : query.codigoUbicacion;

                // Solo aplicamos la lista si corresponde a la sede y al módulo que se están viendo
                if (String(payload.uidModulo) !== String(query.uidModulo)) return;
                if (String(payload.codigoUbicacion) !== String(codigoUbicacionActual)) return;
            }

            setData(lista);
        };

        socket.on('lista-modulos-tiposAtencion', handler);

        return () => {
            socket.off('lista-modulos-tiposAtencion', handler);
        };

    }, [socket, query.uidModulo, query.codigoUbicacion, usuario]);

    // Si se está viendo una sede distinta a la del usuario, nos unimos a su sala
    // para recibir los cambios en vivo (al salir de la página o cambiar de sede, salimos).
    useEffect(() => {

        if (!socket || !query.codigoUbicacion) return;
        if (query.codigoUbicacion === usuario.codigoUbicacion) return; // esa sala ya entra por defecto

        const sala = {
            codigoEntidad: usuario.codigoEntidad,
            codigoUbicacion: query.codigoUbicacion
        };

        const unirse = () => socket.emit('unirse-ubicacion', sala);

        unirse();
        socket.on('connect', unirse); // al reconectar hay que volver a unirse

        return () => {
            socket.off('connect', unirse);
            socket.emit('salir-ubicacion', sala);
        };

    }, [socket, query.codigoUbicacion, usuario]);

    const handleChecked = async (seleccion) => {

        const uidTipoAtencion = seleccion.target.id;
        const checked = seleccion.target.checked;
        if (query.uidModulo === "") return;

        // Actualización optimista
        setData(prev => prev.map(it =>
            it.uidTipoAtencion === uidTipoAtencion ? { ...it, checked } : it
        ));

        try {

            setIsLoading(true);

            const codigoEntidad = usuario.codigoEntidad;
            if (codigoEntidad === "") return;
            const codigoUbicacion = query.codigoUbicacion === "" ? usuario.codigoUbicacion : query.codigoUbicacion;

            const resp = await serverApi.put(
                `/modulos/modulo-tipoAtencion-edita`,
                {
                    ...query,
                    codigoEntidad,
                    codigoUbicacion,
                    uidTipoAtencion,
                    checked
                }
            );

            if (resp.data.ok === false) {
                console.error("Error al editar tipo de atención:", resp.data.resp);
                // Revertir
                setData(prev => prev.map(it =>
                    it.uidTipoAtencion === uidTipoAtencion ? { ...it, checked: !checked } : it
                ));
            }

        } catch (error) {
            console.error("Error al editar tipo de atención", error);
            // Revertir
            setData(prev => prev.map(it =>
                it.uidTipoAtencion === uidTipoAtencion ? { ...it, checked: !checked } : it
            ));
        } finally {
            setIsLoading(false);
        }

    }


    const handleSelectUbicacion = (selected) => {
        const nuevaUbicacion = selected.data;

        setQuery(prev => ({
            ...prev,
            ideUbicacion: selected.value,
            codigoUbicacion: nuevaUbicacion,
            // El módulo seleccionado pertenecía a la otra sede: se limpia para no editar con datos viejos
            uidModulo: ''
        }));

        // Limpiamos lo que se mostraba de la sede anterior
        setModulo([]);
        setData([]);
        setBuscar('');

        // Refrescamos módulo y tabla con la sede recién seleccionada
        cargarModulos(nuevaUbicacion);
        cargarTiposAtencion({ codigoUbicacion: nuevaUbicacion, uidModulo: '' });
    };

    const handleSelectModulo = (selected) => {
        setQuery(prev => ({
            ...prev,
            uidModulo: selected.value,
        }));
        setBuscar('');
    };

    const total = data.length;
    const asignados = data.filter(t => t.checked).length;
    const visibles = data.filter(t => (t.tipoAtencion || '').toLowerCase().includes(buscar.trim().toLowerCase()));


    if (usuario.uidUsuario === null) {
        return (<></>)
    }
    else if (!pantallas.includes("tiposatencion")) {
        return (<NoAcceso />)
    } else {
        return (
            <>

                {isLoading && <LoadingOverlay />}
                <div className={`content ${isLoading ? 'opacity' : ''}`} style={{ padding: '0 24px 24px', fontFamily: "'Inter', Arial, sans-serif" }}>

                    <div style={{ maxWidth: 1320, margin: '0 auto' }}>

                        <div style={{
                            background: 'white', borderRadius: 16, overflow: 'hidden',
                            boxShadow: '0 4px 20px rgba(0,0,0,0.06)', border: '1px solid #e2e8f0',
                        }}>

                            {/* Header de la card */}
                            <div style={{
                                padding: '20px 26px', background: '#f8fafc', borderBottom: '1px solid #e2e8f0',
                                display: 'flex', flexWrap: 'wrap', gap: 14, justifyContent: 'space-between', alignItems: 'center',
                            }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
                                    <div style={{
                                        width: 46, height: 46, borderRadius: 14,
                                        background: 'linear-gradient(135deg, var(--color-primario) 0%, var(--color-secundario) 100%)',
                                        color: 'var(--color-marca-contraste)', display: 'flex', alignItems: 'center', justifyContent: 'center',
                                        fontSize: 20, boxShadow: '0 4px 14px rgba(var(--color-primario-rgb),0.3)',
                                    }}>
                                        <i className="fa-solid fa-diagram-project"></i>
                                    </div>
                                    <div>
                                        <h4 style={{ margin: 0, fontWeight: 800, fontSize: 18, color: '#0f172a' }}>Tipos de atención por módulo</h4>
                                        <p style={{ margin: '2px 0 0', fontSize: 12.5, color: '#64748b' }}>
                                            Asigna los tipos de atención que atiende cada módulo
                                        </p>
                                    </div>
                                </div>

                                {query.uidModulo && (
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
                                        <span style={{ ...chipStyle, ...chipOk }}>
                                            <i className="fa-solid fa-circle-check"></i> Asignados: <b>{asignados}</b>
                                        </span>
                                        <span style={chipStyle}>
                                            <i className="fa-solid fa-list-check"></i> Total: <b>{total}</b>
                                        </span>
                                    </div>
                                )}
                            </div>

                            {/* Barra de herramientas */}
                            <div style={{
                                padding: '16px 26px', borderBottom: '1px solid #f1f5f9',
                                display: 'flex', flexWrap: 'wrap', gap: 14, alignItems: 'flex-end',
                            }}>
                                <div style={{ width: 300, maxWidth: '100%' }}>
                                    <label style={{ fontSize: 12, fontWeight: 700, color: '#475569', display: 'block', marginBottom: 6 }}>
                                        Sede / Ubicación
                                    </label>
                                    <SelectElement
                                        options={ubicaciones}
                                        name={`idUbicacion`}
                                        isMulti={false}
                                        closeOnMenuSelect={true}
                                        value={ubicaciones.find(u => u.value === query.ideUbicacion)}
                                        onChange={(selected) => handleSelectUbicacion(selected)}
                                        classname=""
                                        isClearable={false}
                                        fontSize="13.5px"
                                    />
                                </div>

                                <div style={{ width: 340, maxWidth: '100%' }}>
                                    <label style={{ fontSize: 12, fontWeight: 700, color: '#475569', display: 'block', marginBottom: 6 }}>
                                        Módulo
                                    </label>
                                    <SelectElement
                                        key={`modulo-${query.codigoUbicacion}`}
                                        options={modulo}
                                        name={"modulo"}
                                        isMulti={false}
                                        closeOnMenuSelect={true}
                                        value={modulo.find(u => u.value === query.uidModulo) || null}
                                        onChange={(selected) => handleSelectModulo(selected)}
                                        classname=""
                                        isClearable={false}
                                        fontSize="13.5px"
                                    />
                                </div>

                                {query.uidModulo && (
                                    <div style={{ position: 'relative', flex: 1, maxWidth: 300, minWidth: 200 }}>
                                        <label style={{ fontSize: 12, fontWeight: 700, color: '#475569', display: 'block', marginBottom: 6 }}>
                                            Filtrar
                                        </label>
                                        <i className="fa-solid fa-magnifying-glass" style={{
                                            position: 'absolute', left: 13, top: 'calc(50% + 11px)', transform: 'translateY(-50%)',
                                            color: '#94a3b8', fontSize: 13,
                                        }} />
                                        <input
                                            type='text'
                                            placeholder='Buscar tipo de atención...'
                                            value={buscar}
                                            onChange={(ev) => setBuscar(ev.target.value)}
                                            style={{
                                                width: '100%', padding: '10px 12px 10px 38px', borderRadius: 10,
                                                border: '1.5px solid #e2e8f0', fontSize: 13.5, outline: 'none',
                                                background: '#f8fafc',
                                            }}
                                            onFocus={(e) => { e.target.style.borderColor = 'var(--color-primario)'; e.target.style.background = '#ffffff'; }}
                                            onBlur={(e) => { e.target.style.borderColor = '#e2e8f0'; e.target.style.background = '#f8fafc'; }}
                                        />
                                    </div>
                                )}
                            </div>

                            {/* Lista de tipos de atención */}
                            <div style={{ padding: '18px 26px', background: '#f8fafc' }}>
                                {!query.uidModulo ? (
                                    <div style={{ padding: '48px 20px', textAlign: 'center' }}>
                                        <div style={{ color: '#94a3b8', fontSize: 34, marginBottom: 8 }}>
                                            <i className="fa-solid fa-diagram-project"></i>
                                        </div>
                                        <div style={{ fontWeight: 700, color: '#64748b', fontSize: 15 }}>
                                            Selecciona un módulo
                                        </div>
                                        <div style={{ color: '#94a3b8', fontSize: 13, marginTop: 4 }}>
                                            Elige la sede y el módulo para asignarle sus tipos de atención.
                                        </div>
                                    </div>
                                ) : visibles.length === 0 ? (
                                    <div style={{ padding: '40px 20px', textAlign: 'center' }}>
                                        <div style={{ color: '#94a3b8', fontSize: 30, marginBottom: 8 }}>
                                            <i className="fa-solid fa-list-check"></i>
                                        </div>
                                        <div style={{ fontWeight: 700, color: '#64748b', fontSize: 14 }}>
                                            No hay tipos de atención que coincidan con el filtro
                                        </div>
                                    </div>
                                ) : (
                                    <div style={{ maxHeight: 520, overflowY: 'auto', paddingRight: 2 }}>
                                        {visibles.map((item) => {
                                            const color = item.color || 'var(--color-primario)';
                                            return (
                                                <div
                                                    key={item.uidTipoAtencion}
                                                    style={{
                                                        display: 'flex', alignItems: 'center', gap: 14,
                                                        background: 'white', borderRadius: 12,
                                                        border: `1.5px solid ${item.checked ? 'var(--color-primario-borde)' : '#e2e8f0'}`,
                                                        padding: '12px 16px', marginBottom: 10,
                                                    }}
                                                >
                                                    <div style={{
                                                        width: 38, height: 38, borderRadius: 10, flexShrink: 0,
                                                        background: item.checked ? `${color}1f` : '#f1f5f9',
                                                        color: item.checked ? color : '#94a3b8',
                                                        display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 16,
                                                    }}>
                                                        <i className="fa-solid fa-list-check"></i>
                                                    </div>

                                                    <div style={{ flex: 1, minWidth: 0 }}>
                                                        <div style={{ fontWeight: 800, color: '#0f172a', fontSize: 14, display: 'flex', alignItems: 'center', gap: 8 }}>
                                                            {(item.tipoAtencion || '').toUpperCase()}
                                                        </div>
                                                        <div style={{ color: '#64748b', fontSize: 12, marginTop: 2, display: 'inline-flex', alignItems: 'center', gap: 6 }}>
                                                            <span style={{
                                                                width: 12, height: 12, borderRadius: 4, display: 'inline-block',
                                                                backgroundColor: color, border: '1.5px solid #e2e8f0',
                                                            }} />
                                                            {color}
                                                        </div>
                                                    </div>

                                                    <span style={item.checked ? { ...chipStyle, ...chipOk } : { ...chipStyle, ...chipNo }}>
                                                        {item.checked ? <i className="fa-solid fa-check"></i> : <i className="fa-solid fa-minus"></i>}
                                                        {item.checked ? 'Asignado' : 'No asignado'}
                                                    </span>

                                                    <input
                                                        type="checkbox"
                                                        checked={item.checked}
                                                        id={`${item.uidTipoAtencion}`}
                                                        onChange={(seleccion) => handleChecked(seleccion)}
                                                        style={{ width: 18, height: 18, accentColor: 'var(--color-primario)', cursor: 'pointer' }}
                                                    />
                                                </div>
                                            );
                                        })}
                                    </div>
                                )}
                            </div>

                        </div>
                    </div>

                </div>
            </>
        )
    }
}
